module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-5-e2506e87a6da77443eaeb007979e4b6b.webp";